import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import FormCheckbox from '../../components/form/FormCheckbox/FormCheckbox';

const FormCheckboxContainer = props =>
  <Field
    name={props.name}
    component={FormCheckbox}
    props={props}
  />
;

// TODO
// 1. this state.form.checkout is a hardcoded reference. Make it dynamic!
// 2. this container is rendered twice, stop this from happening, samething's happening to FormRadioContainer
const mapStateToProps = (state, ownProps) => {
  let isChecked = false;
  if (state.form.checkout.values) {
    const selectedValue = state.form.checkout.values[ownProps.name];
    isChecked = !!selectedValue;
  }
  return { checked: isChecked, props: ownProps };
};

FormCheckboxContainer.propTypes = {
  name: PropTypes.string
};

export default connect(mapStateToProps)(FormCheckboxContainer);



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormCheckboxContainer.js
 **/